<table class="common-style">
  <tr>
    <th>{{'date handout' | translate: ['tmc-common.ui.equipment-log.date-handout', translationService.language]}}</th>
    <th>{{'date takeback' | translate: ['tmc-common.ui.equipment-log.date-takeback', translationService.language]}}</th>
    <th>{{'note' | translate: ['tmc-common.ui.equipment-log.note', translationService.language]}}</th>
  </tr>
  <tr *ngFor="let equipmentLog of equipmentLogs">
    <td>{{equipmentLog.handOut | timestamp}}</td>
    <td>{{equipmentLog.takeBack | timestamp}}</td>
    <td>{{equipmentLog.note}}</td>
  </tr>
</table>
